var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-8 col-sm-10 mx-auto"
  }, [_c('div', {
    staticClass: "notification-card"
  }, [_c('div', {
    staticClass: "notification-head mb-3 d-flex gap-3 flex-wrap flex-md-nowrap"
  }, [_c('div', {
    staticClass: "notification-icon d-flex justify-content-center align-items-center flex-shrink-0"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M5 9a7 7 0 0 1 14 0v3.764l1.822 3.644A1.1 1.1 0 0 1 19.838 18h-3.964a4.002 4.002 0 0 1-7.748 0H4.162a1.1 1.1 0 0 1-.984-1.592L5 12.764zm5.268 9a2 2 0 0 0 3.464 0zM12 4a5 5 0 0 0-5 5v3.764a2 2 0 0 1-.211.894L5.619 16h12.763l-1.17-2.342a2 2 0 0 1-.212-.894V9a5 5 0 0 0-5-5"
    }
  })])])]), _vm._m(0)]), _c('div', {
    staticClass: "notification_preference_wrapper"
  }, [_c('div', {
    staticClass: "select_category_wrapper"
  }, [_c('select', {
    staticClass: "form-select mt-2",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function change($event) {
        return _vm.getMessageCenterList($event);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Category")]), _vm._l(_vm.categoryList, function (category) {
    return _c('option', {
      key: category.id,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.name))]);
  })], 2)]), _vm.messageCenterList.length > 0 ? _c('div', {
    staticClass: "selected_category_list mt-3"
  }, [_c('div', {
    staticClass: "selected_title_wrapper d-flex justify-content-between gap-3 align-items-center mb-4"
  }, [_c('h6', {
    staticClass: "title-wrapper mb-0"
  }, [_vm._v(" " + _vm._s(_vm.selectedCategory) + " ")]), _c('div', {
    staticClass: "toggle-switch switch-box ms-1"
  }, [_c('label', {
    staticClass: "switch",
    attrs: {
      "for": "invoice"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "invoice"
    },
    domProps: {
      "checked": !_vm.isAnyUnsubscribed
    },
    on: {
      "change": function change($event) {
        return _vm.subscribeUnsubscribeAll($event);
      }
    }
  }), _c('div', {
    staticClass: "slider round"
  })])])]), _c('ul', {
    staticClass: "listwrapper d-flex flex-column gap-4 mb-0"
  }, _vm._l(_vm.messageCenterList, function (message) {
    return _c('li', {
      key: message.id,
      staticClass: "list_items d-flex"
    }, [_c('div', {
      staticClass: "toggle-switch switch-box ms-1"
    }, [_c('label', {
      staticClass: "switch",
      attrs: {
        "for": "invoices" + message.id
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": "invoices" + message.id
      },
      domProps: {
        "checked": !_vm.selectedEmailConfig.includes(message.id.toString())
      },
      on: {
        "change": function change($event) {
          return _vm.subscribeUnsubscribeManully($event, message.id);
        }
      }
    }), _c('div', {
      staticClass: "slider round"
    })])]), _vm._v(" " + _vm._s(message.label) + " ")]);
  }), 0)]) : _vm._e()])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notification-title"
  }, [_c('h1', {
    staticClass: "mb-1"
  }, [_vm._v("Email Notification")]), _c('p', [_vm._v(" Manage which notifications you want to receive. Turn them on or off anytime to stay updated without unnecessary alerts ")])]);
}]

export { render, staticRenderFns }